var map = {
	"./BigCheck.svg": "a417",
	"./Calendar.svg": "0a10",
	"./Eye.svg": "c539",
	"./JabberLogo.svg": "51fd",
	"./JabberLogo1.svg": "58c8",
	"./LebaraActive.svg": "a074",
	"./LebaraBrand.svg": "1f69",
	"./LebaraDisabeld.svg": "656c",
	"./Lock.svg": "dd81",
	"./Logo.svg": "1b94",
	"./Logo1.svg": "d651",
	"./LogoText.svg": "df6b",
	"./LogoW.svg": "f132",
	"./MobilyActive.svg": "accc",
	"./MobilyBrand.svg": "6663",
	"./MobilyDisabeld.svg": "5b0d",
	"./RedBullActive.svg": "0c71",
	"./RedBullBrand.svg": "07d4",
	"./RedBullDisabeld.svg": "35ee",
	"./STCActive.svg": "8fa7",
	"./STCBrand.svg": "df70",
	"./STCDisabeld.svg": "5a47",
	"./SalamActive.svg": "ceb1",
	"./SalamBrand.svg": "13c2",
	"./SalamDisabeld.svg": "b950",
	"./User.svg": "e253",
	"./ZainActive.svg": "84b0",
	"./ZainBrand.svg": "4f56",
	"./ZainDisabeld.svg": "2d2c",
	"./check.svg": "c43c",
	"./connect.svg": "5b76",
	"./disConnected.svg": "99b2",
	"./folder.svg": "647d",
	"./logoMobily.svg": "c63c",
	"./logoSTC.svg": "806a",
	"./logoTextMobily.svg": "39d6",
	"./logoTextSTC.svg": "7096",
	"./logoTextZain.svg": "b219",
	"./logoWMobily.svg": "77c7",
	"./logoWSTC.svg": "0050",
	"./logoWZain.svg": "3ecc",
	"./logoZain.svg": "b689",
	"./success_tick_icon.svg": "a62b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2a0";